import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { 
  FEEDBACK_SESSION_STATUSES,
  getStatusColor,
  getStatusTextColor,
  getStatusBorderColor
} from '../../../constants/feedbackSessionStatuses';

const CompletedReportsFilter = ({ 
  isSelected = false, 
  onToggle,
  label = "Finished Reports Only",
  sx = {} 
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      <FilterChip
        label={label}
        isSelected={isSelected}
        onClick={onToggle}
        backgroundColor={getStatusColor(FEEDBACK_SESSION_STATUSES.COMPLETED)}
        textColor={getStatusTextColor(FEEDBACK_SESSION_STATUSES.COMPLETED)}
        borderColor={getStatusBorderColor(FEEDBACK_SESSION_STATUSES.COMPLETED)}
        showDot={true}
      />
    </Box>
  );
};

export default CompletedReportsFilter; 